import React from 'react';
import { IonList, IonCheckbox, IonItem } from '@ionic/react';
import { CheckboxChangeEventDetail } from '@ionic/core';
import './CheckboxList.css';
import { AvailableValues } from '../../api/types/generated/filterData_get.response';

interface ICheckboxListProps {
  onChange: (value: string) => void;
  items: AvailableValues;
  slot?: string;
  values?: string[];
}

export default function CheckboxList({
  items,
  values,
  onChange,
}: ICheckboxListProps) {
  const handleChange = ({ detail }: CustomEvent<CheckboxChangeEventDetail>) => {
    onChange(detail.value);
  };

  return (
    <IonList className="checkbox-list">
      {items.map(({ key, label }) => (
        <IonItem lines="none" key={key}>
          <IonCheckbox
            slot="start"
            labelPlacement="end"
            value={key}
            onIonChange={handleChange}
            checked={values?.includes(key) || false}
          >
            {label}
          </IonCheckbox>
        </IonItem>
      ))}
    </IonList>
  );
}
